import React from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export const SectionSix = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });


    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });



    return (
        <div className="section-six-Ind">
            <div >
                <div className="testimonial-content-Ind flex  gap-5" style={{ flexDirection: "column" }}>
                    <div className="testimonial-text-Ind">Why Settle for Low ROAS <br /> When 20X is Possible?</div>
                    <div style={{ width: "100%", maxWidth: !isMobile?'1000px':"600px", margin: "0 auto" }}>
                        <img
                            src="/assets/images/keIndia/chart.png"
                            alt="Chart"
                            style={{ width: "100%", height: "auto" }}
                        />
                    </div>

                </div>

                <div >


                </div>
            </div>
        </div>
    );
};
